import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ItemLabelIconProps {
	labelId: number;
}

const ItemLabelIcon: React.FC<ItemLabelIconProps> = ({ labelId }) => {
	return (
		<>
			{labelId === 1 && <FontAwesomeIcon icon="thumbs-up" />}
			{labelId === 2 && <FontAwesomeIcon icon="dove" />}
			{labelId === 3 && <FontAwesomeIcon icon="fish" />}
			{labelId === 4 && <FontAwesomeIcon icon="microphone" />}
			{labelId === 5 && <FontAwesomeIcon icon="award" />}
			{labelId === 6 && <FontAwesomeIcon icon="carrot" />}
			{labelId === 9 && <FontAwesomeIcon icon="asterisk" />}
		</>
	);
};

export default ItemLabelIcon;